// PartsComponent.js
import React, { useEffect, useContext } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { PartsContext } from './PartsContext';

const PartsComponent = () => {
  const { sparePartListId } = useParams();
  const navigate = useNavigate();
  const { parts, setParts } = useContext(PartsContext);

  useEffect(() => {
    async function fetchParts() {
      try {
        const response = await axios.get(`http://161.97.115.122:5000/parts/${sparePartListId}`);
        setParts(response.data);
      } catch (error) {
        console.error("Błąd podczas pobierania części:", error);
      }
    }
    fetchParts();
  }, [sparePartListId, setParts]);

  return (
    <div className="app-container">
      <div className="sidebar">
        <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />
        <div className="menu">
          <ul>
            <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
            <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
            <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>
            <li><button className="logout-button">Wyloguj się</button></li>
          </ul>
        </div>
      </div>
      <div className="content">
        <button onClick={() => navigate(-1)} className="back-button">Wstecz</button>
        <div className="katalog">
          <h1>Części</h1>
          <ul>
            {parts.map(part => (
              <li key={part._id}>
                <Link to={`/items/${part._id}`}>{part.nazwa}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PartsComponent;
